/*
 * Localization Panel — Country → Language Sync
 * --------------------------------------------------------------------------
 * The "Land & Sprache" panel (header, mobile drawer, footer, announcement
 * bar) lets a visitor change country and language independently, each via
 * its own native Shopify localization form (see snippets/localization-panel
 * .liquid and the inline copies in footer.liquid / announcement-bar.liquid).
 *
 * Shopify's localization endpoint only touches the fields that are actually
 * submitted. The country form only carries `country_code`, so switching
 * country alone keeps whatever language happened to be active — even when
 * that language isn't meant to be offered in the new market (see Theme
 * settings → Localization → "Hide languages per country"). Example: browsing
 * the DE market in German, then switching the country to France lands on
 * /de-fr instead of the market's default /fr-fr.
 *
 * This listens for country selections (capture phase, so it runs before
 * bundle.js's own click handler submits the form) and adds a `locale_code`
 * field carrying that market's default language, taken from
 * window.theme.countryLocaleMap (window.theme.availableLocales | published
 * languages only). The language-only form is untouched, since it has no
 * `country_code` field to key off.
 */
(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      var item = event.target.closest('[data-localization-item]');
      if (!item || !item.dataset.value) return;

      var form = item.closest('form');
      if (!form) return;

      var countryInput = form.querySelector('input[name="country_code"]');
      if (!countryInput) return; // language-only form — leave native behaviour alone

      var theme = window.theme || {};
      var map = theme.countryLocaleMap || {};
      var available = theme.availableLocales || [];

      var targetLocale = map[item.dataset.value.toUpperCase()];
      if (!targetLocale || available.indexOf(targetLocale) === -1) return;

      var localeInput = form.querySelector('input[name="locale_code"]');
      if (!localeInput) {
        localeInput = document.createElement('input');
        localeInput.type = 'hidden';
        localeInput.name = 'locale_code';
        form.appendChild(localeInput);
      }
      localeInput.value = targetLocale;
    },
    true
  );
})();
